var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookWithDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#69DAF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16C28.798 16 24.15 16.029 20 18.008C15.85 16.029 11.202 16 11 16C10.7348 16 10.4804 16.1054 10.2929 16.2929C10.1054 16.4804 10 16.7348 10 17V26.883C10 27.0172 10.027 27.15 10.0794 27.2735C10.1318 27.397 10.2085 27.5087 10.305 27.602C10.5 27.79 10.785 27.907 11.034 27.882L11.161 27.881C11.844 27.881 15.457 27.979 19.577 29.906C19.593 29.914 19.611 29.911 19.627 29.917C19.746 29.966 19.871 30 20 30C20.129 30 20.254 29.966 20.374 29.917C20.39 29.911 20.408 29.914 20.424 29.906C24.544 27.978 28.157 27.881 28.84 27.881L28.967 27.882C29.205 27.907 29.5 27.79 29.696 27.602C29.89 27.413 30 27.153 30 26.883V17C30 16.7348 29.8946 16.4804 29.7071 16.2929C29.5196 16.1054 29.2652 16 29 16ZM12 18.049C13.485 18.16 16.381 18.529 19 19.741V27.483C16 26.308 13.41 25.989 12 25.907V18.049ZM28 25.907C26.59 25.989 24 26.308 21 27.483V19.741C23.619 18.529 26.515 18.16 28 18.049V25.907Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16C21.6569 16 23 14.6569 23 13C23 11.3431 21.6569 10 20 10C18.3431 10 17 11.3431 17 13C17 14.6569 18.3431 16 20 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWithDot);
export default __webpack_public_path__ + "static/media/book-with-dot.4b3753725d916976d1982fa736053025.svg";
export { ForwardRef as ReactComponent };